import { createAction, props } from '@ngrx/store';
import { FinancialInfo } from '@redux/reducers/financial-info.reducer';

export const fullUpdateFinancialInfo = createAction(
  '[Financial Info] Full update',
  props<{ newfinancialInfo: FinancialInfo }>()
);
